// Theme toggle — sidebar footer icon button (§14.13).
// One click cycles: light → dark → system → light.

import { Sun, Moon, Monitor } from 'lucide-react'
import { useTheme } from '@synvya/portal-ui/theme'
import type { ThemePreference } from '@synvya/portal-ui/theme'

const CYCLE: ThemePreference[] = ['light', 'dark', 'system']

const ICONS: Record<ThemePreference, typeof Sun> = {
  light: Sun,
  dark: Moon,
  system: Monitor,
}

const LABELS: Record<ThemePreference, string> = {
  light: 'Light mode',
  dark: 'Dark mode',
  system: 'System theme',
}

/** `iconOnly` drops the text beside the icon (the sidebar rail); title and aria-label stay. */
export function ThemeToggle({ iconOnly = false }: { iconOnly?: boolean }) {
  const { preference, setPreference } = useTheme()

  function cycle() {
    const idx = CYCLE.indexOf(preference)
    const next = CYCLE[(idx + 1) % CYCLE.length]
    setPreference(next)
  }

  const Icon = ICONS[preference]

  return (
    <button
      onClick={cycle}
      className="flex items-center gap-2 rounded-md p-2 text-muted-foreground hover:bg-accent hover:text-foreground"
      aria-label={LABELS[preference]}
      title={LABELS[preference]}
    >
      <Icon className="h-4 w-4" />
      {!iconOnly && <span className="text-xs">{LABELS[preference]}</span>}
    </button>
  )
}
